import React from 'react'
import { useState,useRef } from 'react'
import Navbar from '../Navbar';
import Footer from '../Footer';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MotorPage = () => {
  
    const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
  
  
    const { t } = useTranslation();

       const navigate = useNavigate();
    const [loading, setLoading] = useState(false); 
    const [formData,setFormData]= useState({ firstName: "", mobileNo: "" });
    const [errors,setErrors]=useState({});
    const [isChecked, setIsChecked] = useState(false);

    const firstNameRef= useRef(null);
    const mobileNoRef= useRef(null);

     const handleChange = (e) => {
    const { name, value } = e.target;
     const trimValue = value.trimStart();

    const numberRegex = /^[0-9]*$/;
     const nameRegex = /^[A-Za-z\s]*$/;

    
    


   if (name==="mobileNo") {
    if (numberRegex.test(trimValue)) {
       setFormData({ ...formData, [name]: trimValue });
    }
    return; 
  }
   
 if(name==="checkBox"){
     setIsChecked(e.target.checked)
      return;
 }
  
 if (name === "firstName" ){
    if( nameRegex.test(trimValue)) {
setFormData({ ...formData, [name]: trimValue });
  }
return;
}

   else {
    setFormData({ ...formData, [name]: trimValue });
  }
};



  // form validation function
  const validateForm = () => {
  let newErrors = {};
   
  // Validate fields
  if (!formData.mobileNo?.trim()) {
    newErrors.mobileNo = "Mobile number is required";
  } 

  if (!formData.firstName?.trim()) {
    newErrors.firstName = "Full name is required";
  }
 if (!isChecked) {
      newErrors.checkBox="accept is required";
    } 

  setErrors(newErrors);

  
  if (Object.keys(newErrors).length > 0) {
    const firstErrorField = Object.keys(newErrors)[0];
    switch (firstErrorField) {
      case "mobileNo":
        mobileNoRef.current.focus();
        break;
      case "firstName":
        firstNameRef.current.focus();
        break;

      default:
        break;
    }
    return false; 
  }

  return Object.keys(newErrors).length ===0; // If no errors, return true
};
 
  const handleValidation = (e) => {
    
              const { name } = e.target;
     if (formData[name]?.trim()) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
    
         }


         const handleSubmit=(e,clicked)=>{
          debugger
          e.preventDefault();

          if(validateForm()){
            try{
            setLoading(true);
            if(clicked==="buy_policy"){
              sessionStorage.clear();
             sessionStorage.setItem("motorBasicDetails",JSON.stringify(formData));
           navigate("/motor-ins-buy-policy");
          }
          else if(clicked=="renew_policy"){
              sessionStorage.clear();
             sessionStorage.setItem("motorBasicDetails",JSON.stringify(formData));
           navigate("/motor-renew-search");
        }
      }
      catch(err){
        console.log(err)
      }
      finally{
        setLoading(false);
      }

        }
       }

  const [showPolicy,setShowPolicy]=useState(false)

  return (
    <>
          <div className="header_section1">
        <Navbar />

        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">
              {lnstr === "en" ? "Motor Insurance" : "تأمين السيارات\n"}
            </h3>
          </div>
        </div>
      </div>

      <div className="features_section">
        <div className="container">
          <div className="row d-flex align-items-center justify-content-center">
    
    <div className='border rounded col-md-6 mt-4 p-4' >
      <div className='col-md-12'>
        <label className='mb-0 mt-1'>{t("Name")} <span style={{color:"red"}}>*</span></label>

        <input type="text" className='form-control'
                   ref={firstNameRef}
                     value={formData?.firstName}
                    name='firstName'
                    onChange={handleChange}
                     onBlur={handleValidation}
                    />
                     {errors.firstName && <span style={{ color: "red", fontSize: "12px" }}>{errors.firstName}</span>}
</div>
<div className='col-md-12 mt-3'>
        <label className='mb-0 mt-1'>{t("Mobile Number")}  <span  style={{color:"red"}}>*</span></label>

        <input type="text" className='form-control'
                    ref={mobileNoRef}
                    value={formData?.mobileNo}
                    name='mobileNo'
                   onChange={handleChange}
                    onBlur={handleValidation}
                    />
                    {errors.mobileNo && <span style={{ color: "red", fontSize: "12px" }}>{errors.mobileNo}</span>}
</div>
<div className='col-md-12'>
        <div className=' d-flex align-items-center  mt-2' style={{fontSize:"10px"}} >
          <input type='checkbox' 
                  name='checkBox'
                  className='mx-1'
                   checked={isChecked}
                   onChange={handleChange}
            onBlur={validateForm}
                    style={{marginRight:"5px"}}/>{lnstr=="en"?" I accept the":"أنا أقبل"} <a><span  onClick={()=>{setShowPolicy(true)}} style={{textDecoration:"underline",marginLeft:"2px",cursor:"pointer"}} >{lnstr=="en"?"Privacy policy":"سياسة الخصوصية"}</span></a> {" "}{errors.checkBox && <span style={{ color: "red", fontSize: "10px",marginLeft:"5px" }}>({errors.checkBox})</span>}</div>
                   
        </div>
        <div className='col-md-12'>
          <div className='d-flex justify-content-end '>
            <button className={`btn btn-primary mt-4 mr-3 ${lnstr=="en"?" ":"ml-3"}`} onClick={(e)=>handleSubmit(e,"buy_policy")} >{t("Buy Policy")}</button>
            <button className='btn btn-primary mt-4 ' onClick={(e)=>handleSubmit(e,"renew_policy")} >{t("Renew Policy")}</button>
            </div>
        </div>
    </div>
  </div>
        </div>
      </div>

      <Footer />

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
         {showPolicy && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', overflowY: "auto",  }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content " style={{ maxHeight: "90vh", width: "95vw"  ,maxWidth:"100vw"}}>
                
       {lnstr=="en"?
       <> <div className="modal-header ">
                  <h1 className="modal-title fw-bold text-center" >
                <b>Privacy Policy</b>
                
              </h1>
  <button
    type="button"
    className="btn-close py-1 mt-0"
    style={{ width: "30px" }}
    onClick={() => setShowPolicy(false)}
  >
    ⨯
  </button>
</div>



            <div className="modal-body"      style={{
            overflowY: "auto",
            maxHeight: "75vh",
            textAlign: "justify",
            lineHeight: "1.7",
          }} >
            
              
            
              
              <h6 className="fw-bold">Effective Date: 01.08.2023</h6>

              <h3 className="mt-4 fw-bold"><b>Introduction</b></h3>
              <p>
                Welcome to Dhofar Insurance Company’s Privacy Policy. In this policy, we outline how we collect, use,
                and protect your personal information. Please take the time to read and understand the following
                definitions and interpretations, as they form the basis of this agreement.
              </p>

              <h3 className="mt-4 fw-bold"><b>Interpretation and Definitions</b></h3>
              <h4 className="fw-bold">Interpretation</h4>
              <p>
                The words of which the initial letter is capitalized have meanings defined under the following
                conditions. The following definitions shall have the same meaning regardless of whether they appear in
                singular or in plural.
              </p>

              <h4 className="fw-bold">Definitions</h4>
              <p>For the purposes of this Privacy Policy:</p>
              
              <ul className='p-3'>
                <li><b>Account</b> means a unique account created for you to access our Service or parts of our Service.</li>
                <li><b>Company</b>(referred to as either “the Company,” “We,” “Us,” or “Our” in this Agreement) refers to Dhofar Insurance Company S.A.O.G, P.O. Box 1002 Postal Code 112, Ruwi Sultanate of Oman.</li>
                <li><b>Cookies</b>are small files that are placed on your computer, mobile device, or any other device by a website, containing the details of your browsing history on that website among its many uses.</li>
                <li><b>Country</b> refers to Oman.</li>
                <li><b>Device</b> means any device that can access the Service, such as a computer, a cellphone, or a digital tablet.</li>
                <li><b>Personal Data</b> is any information that relates to an identified or identifiable individual.</li>
                <li><b>Service</b> refers to the Website</li>
                <li><b>Service Provider</b> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service, or to assist the Company in analyzing how the Service is used.</li>
                <li><b>Third-party Social Media Service</b> refers to any website or any social network website through which a User can log in or create an account to use the Service.</li>
                <li><b>Usage Data</b> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</li>
                <li><b>Website</b> refers to Dhofar Insurance, accessible from http://dhofarinsurance.com</li>
                <li><b>You</b> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
              </ul>

              <h3 className="mt-4 fw-bold"><b>Collecting and Using Your Personal Data</b></h3>
              <h4><b>Types of Data Collected</b></h4>
              <h4>Personal Data</h4>
              <p>
                While using our Service, we may ask you to provide certain personally identifiable information that can
                be used to contact or identify you. Personally identifiable information may include, but is not limited to:
              </p>
              <ul className='p-3'>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Full name</li>
                <li>Address, Country, State, Province, ZIP/Postal code, City</li>
                <li>Civil Id</li>
                <li>Passport / Civil Id document</li>
                <li>Nationality</li>
              </ul>
              
              <h4 className="mt-4 fw-bold">Usage Data</h4>
              <p>Usage Data is collected automatically when using the Service.</p>
              <p>Usage Data may include information such as Your Device’s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>
              <p>When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device’s unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.</p>
              <p>We may also collect information that your browser sends whenever you visit our Service or when you access the Service by or through a mobile device.
Other Data</p>
              <p>During the usage of our Service, we may gather the subsequent details: gender, age, date of birth, ID card / Passport, driver’s license, nationality, residential address, contact numbers, marital status information, family members’ details, Health information, and other relevant data.</p>
             
              <h4 className="mt-4 fw-bold">Tracking Technologies and Cookies</h4>
              <p>
               We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service. The technologies we use may include:
              </p>
              <ul className='p-3'>
                <li><b>Cookies or Browser Cookies:</b> A cookie is a small file placed on Your Device. You can instruct your browser to refuse all Cookies or to indicate when a cookie is being sent. However, if you do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted your browser setting so that it will refuse cookies, our Service may use Cookies.</li>
                <li><b>Flash Cookies:</b> Certain features of our Service may use locally stored objects (or Flash Cookies) to collect and store information about your preferences or your activity on our Service. Flash Cookies are not managed by the same browser settings as those used for Browser Cookies. For more information on how You can delete Flash Cookies, please read “Where can I change the settings for disabling or deleting local shared objects?” available at https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html#main_Where_can_I_change_the_settings_for_disabling__or_deleting_local_shared_objects_</li>
                <li><b>Web Beacons:</b> Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity).</li>
                <li><b>Cookies can be “Persistent” or “Session” Cookies:</b> Persistent Cookies remain on your personal computer or mobile device when you go offline, while Session Cookies are deleted as soon as you close your web browser. Learn more about cookies: What Are Cookies?. We use both Session and Persistent Cookies for the purposes set out below:</li>
                <li><b>Necessary / Essential Cookies Type:</b> Session Cookies Administered by: Us Purpose: These Cookies are essential to provide you with services available through the Website and to enable you to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that you have asked for cannot be provided, and we only use these Cookies to provide you with those services.</li>
                <li><b>Cookies Policy / Notice Acceptance Cookies Type:</b> Persistent Cookies Administered by: Us Purpose: These Cookies identify if users have accepted the use of cookies on the Website.</li>
                <li><b>Functionality Cookies Type:</b> Persistent Cookies Administered by: Us Purpose: These Cookies allow us to remember choices you make when you use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide you with a more personal experience and to avoid you having to re-enter your preferences every time you use the Website.</li>
              </ul>
              <p>For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies section of our Privacy Policy.</p>

              <h4 className="mt-4 fw-bold">Use of Your Personal Data</h4>
              <p>
                The Company may use Personal Data for the following purposes:
              </p>
              <ul className='p-3'>
                <li><b>To provide and maintain our Service:</b>including to monitor the usage of our Service.</li>
                <li><b>To manage your Account</b>to manage your registration as a user of the Service. The Personal Data you provide can give you access to different functionalities of the Service that are available to you as a registered user.</li>
                <li><b>For the performance of a contract</b> the development, compliance, and undertaking of the purchase contract for the products, items, or services you have purchased or of any other contract with us through the Service.</li>
                <li><b>To contact You</b>To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application’s push notifications regarding updates or informative communications related to the functionalities, products, or contracted services, including the security updates, when necessary or reasonable for their implementation.</li>
                <li>To provide you with news, special offers, and general information about other goods, services, and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information.</li>
                <li><b>To manage your requests</b>To attend and manage your requests to us.</li>
                <li><b>For business transfers</b>We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.</li>
                <li><b>For other purposes</b> We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and evaluating and improving our Service, products, services, marketing, and your experience.
We may share your personal information in the following situations</li>
                <li><b>With Service Providers</b>We may share your personal information with Service Providers to monitor and analyze the use of our Service to contact you.</li>
                <li><b>For business transfers</b> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or aortion of Our business to another company.</li>
                <li><b>With Affiliates</b> We may share your information with our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include our parent company and any other subsidiaries, joint venture partners, or other companies that we control or that are under common control with us.</li>
                <li><b>With business partners</b> We may share your information with our business partners to offer you certain products, services, or promotions.</li>
                <li><b>With other users</b> when you share personal information or otherwise interact in public areas with other users, such information may be viewed by all users and may be publicly distributed outside. If you interact with other users or register through a Third-Party Social Media Service, Your contacts on the Third-Party Social Media Service may see your name, profile, pictures, and description of your activity. Similarly, other users will be able to view descriptions of your activity, communicate with you and view your profile.</li>
                <li><b>With Your consent</b> We may disclose your personal information for any other purpose with your consent.</li>
              </ul>

              <h4 className="mt-4 fw-bold">Retention of Your Personal Data</h4>
              <p>
               The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We adhere to a data retention period of 10 years as mandated by law. However, we recognize that certain documents may hold ongoing importance even after the 10-year mark. In such cases, we will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
              </p>
              <p>The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or we are legally obligated to retain this data for longer time periods.</p>

              <h4 className="mt-4 fw-bold">Transfer of Your Personal Data</h4>
              <p>Your information, including Personal Data, is processed at the Company’s operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers
located outside of Your state, province, country, or other governmental jurisdiction where the data protection laws may differ from those from Your jurisdiction.
              </p>
              <p>Your consent to this Privacy Policy, followed by your submission of such information, represents your agreement to that transfer.</p>
              <p>The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy, and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place, including the security of Your data and other personal information.</p>
    

            <h3 className="mt-4 fw-bold"><b>Disclosure of Your Personal Data</b></h3>
              <h4 className="fw-bold">Business Transactions</h4>
              <p>
               If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.
              </p>
              <h4 className="fw-bold">Law enforcement</h4>
              <p>Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency). </p>
              <h4 className="fw-bold">Other legal requirements</h4>
              <p> The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:</p> 
              <ul className='p-3'>
                <li>Comply with a legal obligation</li>
                <li>Protect and defend the rights or property of the Company</li>
                <li>Prevent or investigate possible wrongdoing in connection with the Service</li>
                <li>Protect the personal safety of Users of the Service or the public</li>
                <li>Protect against legal liability</li>
              </ul>
              <h4 className="fw-bold"><b>Security of Your Personal Data</b></h4>
              <p>The security of Your Personal Data is important to us. We employ industry-standard security measures to safeguard your information from unauthorized access, alteration, disclosure, or destruction. These measures include but are not limited to encryption, firewalls, secure socket layer (SSL) technology, and access control. While we strive to protect your personal data to the best of our abilities, it’s important to note that no method of data transmission over the Internet or electronic storage is 100% secure. </p>
              
              <h4 className="mt-4 fw-bold">You're Data Protection Rights</h4>
              <p>We aim to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data.</p>
              <p>If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our systems, please email us at dhofar@dhofarinsurance.com.</p>
              <p>In certain circumstances, you have the following data protection rights:</p>
              <ul className='p-3'>
                <li><b>Right to access</b>- The right to access, update, or delete the information we have on you.</li>
                <li><b>Right of rectification</b>-  You have the right to have your information rectified if that information is inaccurate or incomplete.</li>
                <li><b>Right to object</b>-  You have the right to object to our processing of your Personal Data.</li>
                <li><b>Right of restriction</b>- You have the right to request that we restrict the processing of your personal information.</li>
                <li><b>Right to data portability</b>-  You have the right to be provided with a copy of your Personal Data in a structured, machine-readable, and commonly used format.</li>
                <li><b>The right to withdraw consent</b>- You also have the right to withdraw your consent at any time where we rely on your consent to process your personal information</li>
              </ul>
              <p>Please note that we may ask you to verify your identity before responding to such requests. Once your identity is verified, we will promptly address your request and make any necessary updates or changes to your personal data. We are committed to respecting your data protection rights and will handle your requests in accordance with the applicable data protection laws and regulations.</p>

              <h4 className="mt-4 fw-bold"><b>Children's Privacy</b></h4>
              <p>
               Our Service does not address anyone under the age of 18. We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from anyone under the age of 18 without verification of parental consent, we take steps to remove that information from our servers.
              </p>
              <p>If we need to rely on consent as a legal basis for processing your information and your country requires consent from a parent, we may require your parent’s consent before we collect and use that information.</p>

             <h4 className="mt-4 fw-bold"><b>Links to Other Websites</b></h4>
              <p>Our Service may contain links to other websites that are not operated by us. If you click on a third-party link, you will be directed to that third-party’s site. We strongly advise you to review the Privacy Policy of every site you visit.
              </p>
              <p>We have no control over and assume no responsibility for the content, privacy policies or practices of any third-party sites or services.</p>
              
        

              <h4 className="mt-4 fw-bold"><b>Copyright & Trademarks</b></h4>
              <p>
                DIC owns the trademarks, logos, and service marks displayed on this website. Materials on this site are protected by copyright. No part of these materials may be modified, reproduced, stored in a retrieval system, transmitted, copied, distributed, or used in any other way for commercial or public purposes without DIC’s prior written consent.
              </p>

              <h4 className="mt-4 fw-bold"><b>Changes to this Privacy Policy</b></h4>
              <p>We may update Our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.


              </p>
              <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page. You can refer to the “Last updated” date mentioned at the top of this Privacy Policy.</p>


              <h4 className="mt-4 fw-bold"><b>Contact Us</b></h4>
              <p>
               If you have any questions about this Privacy Policy, You can contact us:</p>
                <ul className='p-3'>
                <li><b>By email:</b> dhofar@dhofarinsurance.com</li>
                <li><b>By phone number:</b> +968 24 705 305  (ext. 130) or (ext. 298)</li>
              </ul>
            </div>
              </>
              :
              <>     <div className="modal-header">
          <h1 className="modal-title fw-bold text-center">
            <b>سياسة الخصوصية</b>
          </h1>
          <button
            type="button"
            className="btn-close py-1 mt-0"
            style={{ width: "30px" }}
            onClick={() => setShowPolicy(false)}
          >
            ⨯
          </button>
        </div>
        
         <div
          className="modal-body"
          style={{
            overflowY: "auto",
            maxHeight: "75vh",
            textAlign: "justify",
            lineHeight: "1.7",
          }}
        >
          <h6 className="fw-bold">تاريخ السريان: 01.08.2023</h6>

          <h3 className="mt-4 fw-bold"><b>المقدمة</b></h3>
          <p>
            مرحبًا بكم في سياسة الخصوصية الخاصة بشركة ظفار للتأمين. في هذه السياسة، نوضح كيفية جمع واستخدام
            وحماية معلوماتكم الشخصية. يرجى تخصيص بعض الوقت لقراءة وفهم التعريفات والتفسيرات التالية، لأنها تشكل أساس هذا الاتفاق.
          </p>

          <h3 className="mt-4 fw-bold"><b>التفسير والتعريفات</b></h3>
          <h4 className="fw-bold">التفسير</h4>
          <p>
            الكلمات التي تبدأ بحرف كبير تحمل معاني محددة وفقًا للشروط التالية. سيكون لهذه التعريفات نفس المعنى
            سواء ظهرت بصيغة المفرد أو الجمع.
          </p>

          <h4 className="fw-bold">التعريفات</h4>
          <p>لأغراض هذه السياسة:</p>

          <ul className='p-3'>
            <li><b>الحساب</b> يعني حسابًا فريدًا يتم إنشاؤه لكم للوصول إلى خدمتنا أو أجزاء منها.</li>
            <li><b>الشركة</b> (يُشار إليها باسم "الشركة"، "نحن"، "لنا" أو "خاصتنا") تشير إلى شركة ظفار للتأمين ش.م.ع.ع، ص.ب 1002 الرمز البريدي 112، روي، سلطنة عمان.</li>
            <li><b>ملفات تعريف الارتباط (الكوكيز)</b> هي ملفات صغيرة يتم وضعها على جهاز الكمبيوتر أو الهاتف المحمول أو أي جهاز آخر، وتحتوي على تفاصيل سجل التصفح الخاص بكم على ذلك الموقع.</li>
            <li><b>البلد</b> يشير إلى سلطنة عمان.</li>
            <li><b>الجهاز</b> يعني أي جهاز يمكنه الوصول إلى الخدمة، مثل الكمبيوتر أو الهاتف المحمول أو الجهاز اللوحي.</li>
            <li><b>البيانات الشخصية</b> هي أي معلومات تتعلق بفرد مُحدد أو قابل للتحديد.</li>
            <li><b>الخدمة</b> تشير إلى الموقع الإلكتروني.</li>
            <li><b>مزود الخدمة</b> يعني أي شخص طبيعي أو اعتباري يعالج البيانات نيابة عن الشركة.</li>
            <li><b>خدمة وسائل التواصل الاجتماعي التابعة لجهة خارجية</b> تشير إلى أي موقع إلكتروني أو شبكة اجتماعية يمكن للمستخدم تسجيل الدخول من خلالها لاستخدام الخدمة.</li>
            <li><b>بيانات الاستخدام</b> تشير إلى البيانات التي يتم جمعها تلقائيًا، سواء من خلال استخدام الخدمة أو من بنيتها الأساسية.</li>
            <li><b>الموقع الإلكتروني</b> يشير إلى موقع ظفار للتأمين.</li>
            <li><b>أنتم</b> يعني الفرد الذي يصل أو يستخدم الخدمة، أو الشركة أو الجهة التي يتم استخدام الخدمة نيابة عنها.</li>
          </ul>

          <h3 className="mt-4 fw-bold"><b>جمع واستخدام بياناتكم الشخصية</b></h3>

          <h4><b>أنواع البيانات التي يتم جمعها</b></h4>
          <h4>البيانات الشخصية</h4>
          <p>
            أثناء استخدام خدمتنا، قد نطلب منكم تقديم معلومات شخصية يمكن استخدامها للتواصل معكم أو التعرف عليكم.
            وقد تشمل هذه المعلومات، على سبيل المثال لا الحصر:
          </p>

          <ul className='p-3'>
            <li>عنوان البريد الإلكتروني</li>
            <li>رقم الهاتف</li>
            <li>الاسم الكامل</li>
            <li>العنوان، الدولة، الولاية، المقاطعة، الرمز البريدي، المدينة</li>
            <li>الرقم المدني</li>
            <li>جواز السفر / بطاقة الهوية</li>
            <li>الجنسية</li>
          </ul>

          <h4 className="mt-4 fw-bold">بيانات الاستخدام</h4>
          <p>يتم جمع بيانات الاستخدام تلقائيًا عند استخدام الخدمة.</p>

          <p>
            قد تشمل بيانات الاستخدام عنوان بروتوكول الإنترنت الخاص بجهازكم، نوع المتصفح، إصدار المتصفح،
            الصفحات التي تزورونها، وقت وتاريخ الزيارة، الوقت المستغرق، معرفات الجهاز، وغيرها من البيانات التشخيصية.
          </p>

          <p>
            عند الوصول إلى الخدمة عبر جهاز محمول، قد نقوم بجمع بيانات مثل نوع الجهاز، رقم التعريف الفريد، عنوان IP،
            نظام التشغيل، نوع المتصفح، ومعرفات الجهاز.
          </p>

          <p>قد نقوم أيضًا بجمع المعلومات التي يرسلها المتصفح عند زيارة خدمتنا.</p>

          <p>بيانات أخرى</p>

          <p>
            أثناء استخدام خدمتنا، قد نقوم بجمع معلومات إضافية مثل: الجنس، العمر، تاريخ الميلاد، بطاقة الهوية / جواز السفر،
            رخصة القيادة، الجنسية، العنوان السكني، أرقام الاتصال، الحالة الاجتماعية، بيانات أفراد الأسرة، المعلومات الصحية،
            وغيرها من البيانات ذات الصلة.
          </p>

          <h4 className="mt-4 fw-bold">تقنيات التتبع والكوكيز</h4>
          <p>
            نستخدم الكوكيز وتقنيات التتبع الأخرى لتعقب النشاط على خدمتنا وتخزين معلومات معينة. تشمل هذه التقنيات الإشارات
            والوسوم والبرمجيات المستخدمة في التحليل وتحسين الخدمة.
          </p>

          <ul className='p-3'>
            <li><b>كوكيز المتصفح:</b> ملف صغير يوضع على جهازكم.</li>
            <li><b>كوكيز الفلاش:</b> تُستخدم لتخزين التفضيلات أو النشاط.</li>
            <li><b>إشارات الويب:</b> ملفات صغيرة تُستخدم لحساب عدد الزوار أو قياس التفاعل.</li>
            <li><b>الكوكيز الدائمة / المؤقتة:</b> الدائمة تبقى بعد الإغلاق، والمؤقتة تُحذف عند إغلاق المتصفح.</li>
            <li><b>كوكيز ضرورية:</b> ضرورية لتشغيل بعض ميزات الموقع.</li>
            <li><b>كوكيز قبول السياسة:</b> تُستخدم لتسجيل قبول المستخدم لاستخدام الكوكيز.</li>
            <li><b>كوكيز الوظائف:</b> تُستخدم لتذكر تفضيلاتكم، مثل اللغة.</li>
          </ul>

          <p>
            لمزيد من المعلومات حول الكوكيز، يرجى زيارة قسم سياسة الكوكيز.
          </p>

          <h4 className="mt-4 fw-bold">استخدام بياناتكم الشخصية</h4>
          <p>قد تستخدم الشركة بياناتكم الشخصية للأغراض التالية:</p>

          <ul className='p-3'>
            <li><b>لتقديم الخدمة والحفاظ عليها</b></li>
            <li><b>لإدارة حسابكم</b></li>
            <li><b>لتنفيذ العقود</b></li>
            <li><b>للتواصل معكم</b></li>
            <li>لتقديم العروض والأخبار والخدمات ذات الصلة</li>
            <li><b>لإدارة طلباتكم</b></li>
            <li><b>لعمليات نقل الأعمال</b></li>
            <li><b>لأغراض تحليلية وتحسينات</b></li>
            <li><b>مع مزودي الخدمة</b></li>
            <li><b>مع الشركاء التجاريين</b></li>
            <li><b>بموافقتكم</b></li>
          </ul>

          <h4 className="mt-4 fw-bold">الاحتفاظ ببياناتكم</h4>
          <p>
            ستحتفظ الشركة ببياناتكم الشخصية طالما كان ذلك ضروريًا للأغراض المذكورة. نلتزم بفترة احتفاظ مدتها 10 سنوات
            وفقًا للقانون. وقد نحتفظ ببعض المستندات لفترة أطول إذا كانت لازمة.
          </p>

          <p>
            بيانات الاستخدام تُحتفظ عادة لفترة أقصر، ما لم يكن الاحتفاظ بها ضروريًا لأسباب أمنية أو قانونية.
          </p>

          <h4 className="mt-4 fw-bold">نقل بياناتكم</h4>
          <p>
            قد يتم نقل بياناتكم إلى خوادم خارج بلدكم، مع اتخاذ جميع التدابير لضمان الحماية.
          </p>

          <h3 className="mt-4 fw-bold"><b>الإفصاح عن بياناتكم</b></h3>

          <h4 className="fw-bold">العمليات التجارية</h4>
          <p>
            قد يتم نقل بياناتكم إذا كانت الشركة طرفًا في عملية دمج أو بيع أصول.
          </p>

          <h4 className="fw-bold">الجهات القانونية</h4>
          <p>
            قد نُفصح عن بياناتكم استجابةً لأوامر قانونية.
          </p>

          <h4 className="fw-bold">متطلبات قانونية أخرى</h4>
          <p>قد نُفصح عن بياناتكم إذا كان ذلك ضروريًا من أجل:</p>

          <ul className='p-3'>
            <li>الامتثال للقانون</li>
            <li>حماية الشركة</li>
            <li>منع المخالفات</li>
            <li>حماية المستخدمين</li>
            <li>الدفاع ضد المسؤولية القانونية</li>
          </ul>

          <h4 className="fw-bold"><b>أمن بياناتكم</b></h4>
          <p>
            نتخذ تدابير أمنية لحماية بياناتكم، مثل التشفير والجدران النارية وSSL. ومع ذلك، لا توجد وسيلة آمنة بنسبة 100%.
          </p>

          <h4 className="mt-4 fw-bold">حقوق حماية البيانات الخاصة بكم</h4>
          <p>نحن نهدف إلى منحكم القدرة على تعديل أو حذف بياناتكم.</p>

          <p>للاستعلام أو حذف بياناتكم، يرجى التواصل معنا عبر البريد الإلكتروني.</p>

          <ul className='p-3'>
            <li><b>حق الوصول</b></li>
            <li><b>حق التصحيح</b></li>
            <li><b>حق الاعتراض</b></li>
            <li><b>حق التقييد</b></li>
            <li><b>حق نقل البيانات</b></li>
            <li><b>حق سحب الموافقة</b></li>
          </ul>

          <p>قد نطلب التحقق من الهوية قبل تنفيذ الطلب.</p>

          <h4 className="mt-4 fw-bold"><b>خصوصية الأطفال</b></h4>
          <p>
            لا نقدم الخدمة لمن هم دون 18 عامًا، ولا نجمع بياناتهم عن قصد.
          </p>

          <p>في حال جمع بيانات طفل عن طريق الخطأ، سنقوم بحذفها.</p>

          <h4 className="mt-4 fw-bold"><b>الروابط الخارجية</b></h4>
          <p>
            قد تحتوي خدمتنا على روابط لمواقع خارجية. لا نتحمل مسؤولية سياسات الخصوصية الخاصة بهم.
          </p>

          <h4 className="mt-4 fw-bold"><b>حقوق النشر والعلامات التجارية</b></h4>
          <p>
            تمتلك شركة ظفار للتأمين العلامات التجارية والمواد الموجودة على هذا الموقع. لا يجوز استخدام أي جزء منها دون إذن كتابي مسبق.
          </p>

          <h4 className="mt-4 fw-bold"><b>التغييرات على سياسة الخصوصية</b></h4>
          <p>
            قد نقوم بتحديث هذه السياسة من حين لآخر. وسيتم نشر التحديثات على هذه الصفحة.
          </p>

          <p>يُنصح بمراجعة هذه الصفحة بشكل دوري.</p>

          <h4 className="mt-4 fw-bold"><b>اتصل بنا</b></h4>
          <p>إذا كان لديكم أي أسئلة حول سياسة الخصوصية، يمكنكم التواصل معنا عبر:</p>

          <ul className='p-3'>
            <li><b>البريد الإلكتروني:</b> dhofar@dhofarinsurance.com</li>
            <li><b>رقم الهاتف:</b> +968 24 705 305 (تحويلة 130) أو (تحويلة 298)</li>
          </ul>

        </div>
        
        </>}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default MotorPage